import validate from 'validate.js'

const constraints = {
  lessonId: {
    presence: true
  },
  cancelFuture: {
    presence: false
  }
}

export default (data) => {
  return validate(data, constraints)
}
